/**
 * @file コンポーネント：段落 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledParagraph = styled.div`
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledParagraphContainer = styled.p`
    font-size: 16px;
    line-height: 24px;
    word-break: break-word;

    &[data-on-color="gray"] {
        color: #000000;
    }

    &[data-on-color="lightGray"] {
        color: #000000;
    }

    &[data-on-color="main"] {
        color: #ffffff;
    }

    &[data-on-color="sub"] {
        color: #ffffff;
    }

    &[data-on-color="white"] {
        color: #757575;
    }

    &[data-paragraph-type="error"] {
        color: #bd0a2e;
    }

    &[data-paragraph-type="success"] {
        color: #427311;
    }
`;
